import React, { useState, useEffect } from 'react';
import OnBoardMenu from '../components/OnBoardMenu';
import HierarchicalStructure from '../components/OrgChart';
import useDropdownData from '../fetches/loadDropDownData';
import '../App.css';

const OrganisationPage = () => {
  // Search and filter state (if needed)
  const [filter, setFilter] = useState('');
  useEffect(() => {
    document.title = 'SUMISNI'; // <-- Change your title here
  }, []);
  const handleSearch = (searchQuery) => {
    console.log('Search initiated for:', searchQuery);
    setFilter(searchQuery);
  };

  // Note: We now destructure "dropdownData" because that's what the hook returns.
  const { dropdownData, loading, error } = useDropdownData();

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <div className="bg-white border-b">
        <OnBoardMenu handleSearch={handleSearch} />
      </div>
      {/* Main Content */}
      <div className="px-4 py-6 max-w-[1920px] mx-auto">
        <HierarchicalStructure data={dropdownData} />
      </div>
    </div>
  );
};

export default OrganisationPage;
